import * as UserTypes from './user.types';
import { IInitialUserState, TUpdateUserPick } from 'interfaces/user.interface';
import moment from 'moment';
import { ISAdminUserTenantState } from 'api/endpoints/superAdmin/superAdmin.response.interface';
import { IloginDbUserAPIResponseData } from 'api/endpoints/user/user.response.interface';
import { superAdminRole } from 'utils/constants';

export type TuserDispatchReducer =
  | {
      type: typeof UserTypes.LOGIN_USER;
      payload: IloginDbUserAPIResponseData;
    }
  | {
      type: typeof UserTypes.LOGIN_COMPANY_USER_SUPER_ADMIN;
      payload: ISAdminUserTenantState;
    }
  | {
      type: typeof UserTypes.UPDATE_USER;
      payload: TUpdateUserPick;
    }
  | {
      type: typeof UserTypes.UPDATE_USER_AVATAR;
      payload: string;
    }
  | {
      type: typeof UserTypes.VERIFY_EMAIL;
      payload: boolean;
    }
  | {
      type: typeof UserTypes.UPDATE_LANGUAGE;
      payload: string;
    }
  | {
      type: typeof UserTypes.SET_IS_LOADING;
      payload: boolean;
    };

export default function userReducer(
  state: IInitialUserState,
  action: TuserDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case UserTypes.LOGIN_USER: {
      const loginUser: IInitialUserState = {
        ...state,
        dbUser: {
          ...payload,
          profile_image: payload?.profile_image
            ? `${payload?.profile_image}?ts=${moment().unix()}`
            : '',
        },
      };
      return loginUser;
    }

    case UserTypes.LOGIN_COMPANY_USER_SUPER_ADMIN: {
      const loginCompanyUserSuperAdmin: IInitialUserState = {
        ...state,
        dbUser: {
          ...payload.user,
          email: payload.user.username,
          role: superAdminRole,
          telephone_prefix: payload.user.tel_prefix,
          telephone_sufix: payload.user.tel_sufix,
          profile_image: payload.user.profile_image
            ? `${payload.user.profile_image}?ts=${moment().unix()}`
            : '',
          user_tenants: [],
        },
      };
      return loginCompanyUserSuperAdmin;
    }

    case UserTypes.UPDATE_USER: {
      const updateUser: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          ...payload,
          telephone_prefix: payload.tel_prefix,
          telephone_sufix: payload.tel_sufix,
        },
      };
      return updateUser;
    }

    case UserTypes.UPDATE_USER_AVATAR: {
      const updateUserAvatar: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          profile_image: `${payload}?ts=${moment().unix()}`,
        },
      };
      return updateUserAvatar;
    }

    case UserTypes.VERIFY_EMAIL: {
      const verifyEmail: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          enabled: payload,
        },
      };
      return verifyEmail;
    }

    case UserTypes.UPDATE_LANGUAGE: {
      const updateLanguage: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          i18n_lang_id: payload,
        },
      };
      return updateLanguage;
    }

    case UserTypes.SET_IS_LOADING: {
      const setIsLoading: IInitialUserState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;
    }

    default:
      return state;
  }
}
